import React, { Component } from 'react';

import { StyledRowHorizontal } from './styles/StyledRowHorizontal';


class RowHorizontal extends Component {
  render() {
    return (
      <StyledRowHorizontal>
        
      </StyledRowHorizontal>
    );
  }
}

export default RowHorizontal;



// WEBPACK FOOTER //
// ./src/common/RowHorizontal/RowHorizontal.js